import { render, staticRenderFns } from "./CampaignMessageBuilder.vue?vue&type=template&id=26531d5c&scoped=true&"
import script from "./CampaignMessageBuilder.vue?vue&type=script&lang=js&"
export * from "./CampaignMessageBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26531d5c",
  null
  
)

export default component.exports